export default "__VITE_ASSET__ed432e7b__"